import React from 'react';


const MealVariantAssignmentNotice = ({ initialVariantCount, draftVariantCount }) => {
  if (initialVariantCount >= 2 || draftVariantCount < 2) return null;

  return (
    <p
      className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-5 text-amber-900"
      data-testid="legacy-variant-assignment-notice"
    >
      Vorherige Buchungen werden Variante 1 zugeordnet und können anschließend von den Mitarbeitenden korrigiert werden.
    </p>
  );
};

export default MealVariantAssignmentNotice;
